export var WaitOfferType;
(function (WaitOfferType) {
    WaitOfferType[WaitOfferType["CALLBACK"] = 0] = "CALLBACK";
    WaitOfferType[WaitOfferType["TRANSFER_SKILLS_LOCALE"] = 1] = "TRANSFER_SKILLS_LOCALE";
    WaitOfferType[WaitOfferType["VOICEMAIL_MESSAGE"] = 2] = "VOICEMAIL_MESSAGE";
})(WaitOfferType || (WaitOfferType = {}));
export var createCallcenterSettingsApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/callcenter");
    var settingsUrl = "".concat(url, "/settings");
    return {
        getGlobalCallOptions: function () { return http.get("".concat(url, "/queues/callOptions")); },
        setGlobalCallOptions: function (dto) { return http.put("".concat(url, "/queues/callOptions"), dto); },
        getCustomBusyStatuses: function () { return http.get("".concat(url, "/customBusyStatuses")); },
        addCustomBusyStatus: function (name) { return http.post("".concat(url, "/customBusyStatuses"), { name: name }); },
        updateCustomBusyStatus: function (_a) {
            var id = _a.id, name = _a.name;
            return http.put("".concat(url, "/customBusyStatuses/").concat(id), { name: name });
        },
        deleteCustomBusyStatus: function (id) { return http.delete("".concat(url, "/customBusyStatuses/").concat(id)); },
        getCallCenterSettings: function () { return http.get(settingsUrl); },
        updateNonAvailableAgentsSettings: function (dto) { return http.put("".concat(settingsUrl, "/nonAvailableAgents"), dto); },
        updateOutOfBusinessHoursSettings: function (dto) { return http.put("".concat(settingsUrl, "/outOfBusinessHours"), dto); },
        updateWaitOfferSettings: function (dto) { return http.put("".concat(settingsUrl, "/waitOffer"), dto); },
        setDefaultNonAvailableAgentsSettings: function (dto) { return http.put("".concat(settingsUrl, "/nonAvailableAgents/default"), dto); },
        setDefaultOutOfBusinessHoursSettings: function (dto) { return http.put("".concat(settingsUrl, "/outOfBusinessHours/default"), dto); },
        setDefaultWaitOfferSettings: function (dto) { return http.put("".concat(settingsUrl, "/waitOffer/default"), dto); },
    };
};
//# sourceMappingURL=index.js.map